import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-brand-bg text-brand-textBody pt-6 pb-12 px-4 overflow-hidden flex flex-col items-center justify-center min-h-[90vh]" data-id="element-83">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-green-200/30 blur-[150px] rounded-full pointer-events-none" data-id="element-84"></div>

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-4" data-id="element-86">
          <span className="inline-flex items-center gap-2 text-green-700 font-bold tracking-widest text-xs md:text-sm uppercase bg-green-100 px-4 py-1.5 rounded-full border border-green-200" data-id="element-87">
            <span data-id="element-88">🥗</span> SALUD EN TU PLATO
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="md:text-7xl lg:text-8xl font-poppins font-black mb-6 tracking-tight text-[36px] text-[#22C55E]" data-id="element-89">
          21 días para bajar de peso
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full max-w-2xl mb-6 relative" data-id="element-90">
          <div className="absolute inset-0 bg-brand-accent/10 blur-[60px] rounded-full" data-id="element-91"></div>
          <img src="https://cdn.magicpatterns.com/uploads/4wrDCz6WG7euGzgDD4rfDL/ChatGPT_Image_22_mar_2026,_05_54_51_p.m..png" alt="Salud en tu Plato - Pack Completo" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-92" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col items-center" data-id="element-93">
          <p className="text-xl md:text-2xl font-medium text-green-700 italic mb-4" data-id="element-94">
            "Listo para usar. Sin dietas extremas. Sin pasar hambre. Sin
            complicarte."
          </p>

          <p className="text-base md:text-lg text-brand-textBody mb-6 max-w-2xl" data-id="element-95">
            El sistema simple para saber qué comer cada día y bajar de peso de
            verdad.
          </p>

          <CTAButton href="#pricing" className="mb-6" data-id="element-96">
            🥗 → QUIERO BAJAR DE PESO AHORA
          </CTAButton>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-3 mb-0" data-id="element-97">
            {['📄 PDF', '⚡ Inmediato', '🥗 Recetas reales', '🔥 Método probado'].map((badge, i) => <span key={i} className="bg-white border border-green-200 px-4 py-2 rounded-full text-sm font-medium text-brand-text" data-id="element-98">
                {badge}
              </span>)}
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-xs text-brand-textMuted font-medium mt-6" data-id="element-99">
            <span className="flex items-center gap-1" data-id="element-100">🛡️ Garantía 7 días</span>
            <span className="flex items-center gap-1" data-id="element-101">🔒 Pago seguro</span>
            <span className="flex items-center gap-1" data-id="element-102">
              💳 Mercado Pago | Tarjeta | Transferencia
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}